import Localbase from "localbase";
const ldb = new Localbase("db");
ldb.config.debug = false;
export default ldb;
